if ($('.js-top-nav').data('template') === 'horizontal-multilevel-4') {
	function menuTopBuild() {
		$('.js-top-item-lvl2').has('.js-top-list-lvl3').addClass('has-submenu');
		$('.js-top-item-lvl3').has('.js-top-list-lvl4').addClass('has-submenu');
	};

	if ($.fn.velocity){
		$('.js-top-link').on('click touchstart', function (event) {
			var $this = $(this),
					lvl = 1;
			if ($this.hasClass('js-top-link-lvl2')) {
				lvl = 2;
			} else if ($this.hasClass('js-top-link-lvl3')) {
				lvl = 3;
			} else if ($this.hasClass('js-top-link-lvl4')) {
				lvl = 4;
			}
			openTopMenu ($this, lvl, event);
		});

		function openTopMenu(element, lvl, ev) {
			var $this = element;
			//if (lvl === 1) {
			var showEffect = 'transition.slideDownIn';
			//}  else {
			//	var showEffect = 'transition.slideDownIn';
			//}
			if (!$this.hasClass('is-expand') && $this.parents('.js-top-item-lvl' + lvl).has('.js-top-list-lvl' + (lvl + 1)).length) {
				ev.preventDefault();
				$('.js-top-link-lvl' + lvl + '.is-expand')
					.removeClass('is-expand')
					.siblings('.js-sub-space, .nav__list')
					.velocity('transition.fadeOut', 200)
					.find('.is-expand')
					.removeClass('is-expand')
					.siblings('.nav__list')
					.velocity('transition.fadeOut');
				$this
					.addClass('is-expand')
					.siblings('.js-sub-space, .nav__list')
					.velocity(showEffect, 200);
			} else {
				$('.is-expand')
					.removeClass('is-expand')
					.siblings('.js-sub-space, .nav__list')
					.velocity('transition.slideUpOut', 200);
			}

			$this.parents('.js-sub-space').height('auto');
			var	thisListHeight = $this.parents('.nav__list').height(),
					childListHeight = $this.siblings('.nav__list').height();
			if (thisListHeight < childListHeight) {
				$this.parents('.js-sub-space').velocity({height: childListHeight}, 200);
			} else {
				$this.parents('.js-sub-space').velocity({height: thisListHeight}, 200);
			}
		};
		$(document).on('click', function (event) {
			if (!$(event.target).closest('.js-top-nav').length) {
				$('.js-top-nav .is-expand')
					.removeClass('is-expand')
					.siblings('.js-sub-space, .js-sub-space .nav__list')
					.velocity('transition.slideUpOut', 200);
				$('.js-sub-space').height('auto');
			}
		});
	} else {
		console.error('Menu: Для работы меню необходимо подключить VelocityJS и VelocityJS UI Pack');
	}
	menuTopBuild();
}



/** WEBPACK FOOTER **
 ** ./frontend/components/menu/horizontal-multilevel-4/horizontal-multilevel-4.js
 **/